// Channels are group chats kept in step with a location or one of its
// departments. People can't leave, rename, delete or add to them.
export const channelMembershipText = (conversation) =>
	conversation?.channel === 'location'
		? 'Everyone at this location is in this channel, and new people join automatically.'
		: 'Everyone in this department is in this channel. People join and leave as the department changes in Settings.';
